import React from 'react';

const DownloadIcon = () => {
  return (
    <svg
      width='19'
      height='19'
      viewBox='0 0 19 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.20124 11.4942V2.29883M9.20124 11.4942L5.36982 7.66281M9.20124 11.4942L13.0327 7.66281M16.0978 11.4942V14.5594C16.0978 14.9658 15.9363 15.3556 15.6489 15.6431C15.3615 15.9305 14.9717 16.0919 14.5652 16.0919H3.83725C3.43079 16.0919 3.04098 15.9305 2.75357 15.6431C2.46615 15.3556 2.30469 14.9658 2.30469 14.5594V11.4942'
        stroke='currentColor'
        strokeWidth='1.14943'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default DownloadIcon;
